import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Dashboard from './Components/Dashboard/Dashboard';
import Footer from './Components/ShareComponents/Footer';
import Navbar from './Components/ShareComponents/Navbar';
import BlogPage from './Pages/BlogPage';
import ContactPage from './Pages/ContactPage';
import HomePage from './Pages/HomePage';
import LoginPage from './Pages/LoginPage';
import PageNotFound from './Pages/PageNotFound';
import PortfolioPage from './Pages/PortfolioPage';
import ResumePage from './Pages/ResumePage';

function App() {
    return (
        <div>
            <BrowserRouter>
                <Navbar />
                    <Routes>
                        <Route path="/" element={<HomePage />}></Route>
                        <Route path="/blog" element={<BlogPage />}></Route>
                        <Route path="/Login" element={<LoginPage />}></Route>
                        <Route path="/resume" element={<ResumePage />}></Route>
                        <Route path="/contact" element={<ContactPage />}></Route>
                        <Route path="/portfolio" element={<PortfolioPage />}></Route>
                        <Route path="dashboard/*" element={<Dashboard />}></Route>
                        <Route path="*" element={<PageNotFound />}></Route>
                    </Routes>
            </BrowserRouter>
            <Footer />
        </div>
    );
}

export default App;
